<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="navbar-brand navbar-brand-choose-plan">
		<img src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo" width="125px">
	</section>
</header>
<header class="mobile-header">
	<img src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo" width="125px">
</header>
<section class="container choose-plan-container choose-plan-container-professional">
    <h1 class="serif-title">Free for 7 days, then...</h1>
    <form [formGroup]="choosePlanFormGroup" class="card-payment-choose-plan">
        <section class="price-boxes">
            <div class="items" [ngClass]="{selected:chosenPlan=='perMonth'}" (click)="setPaymentType('perMonth')">
                <div class="ovale ovale-transparent"></div>
                <div class="price-content">
                    <div class="price">£{{price | number}}</div>
                    <div *ngIf="chosenPlan=='perMonth'" class="promotion">Per month</div>
                    <!--div class="promotion">Includes 20<br>client accounts</div-->
                    <div class="promotion"><strong>Billed {{chosenPlan=='perMonth' ? 'monthly' : 'yearly'}} at £{{price|number}}</strong></div>
                </div>
                <div class="round" [ngClass]="{roundClass:chosenPlan=='perMonth'}">
                    <i class="fa fa-2x fas fa-check"></i>
                </div>
            </div>
        </section>
        <section class="cancel-payment">
            <input type="submit" class="btn btn-primary primary-default-btn payment-complete-btn" value="Continue"
                (click)="onSubmit()">
        </section>
        <div class="cancel-text">
            <span>Subscription terms: After 7 days you will be charged £{{price|number}}. You will then be charged £{{price|number}} every
                following {{chosenPlan=='perMonth' ? 'month' : 'year'}}. <!--We will automatically update your account balance if more than 20 accounts are created
                via your client sign-up link.--> Cancel anytime.</span>
        </div>
    </form>
</section>
<app-footer></app-footer>
